/**
 * Returns GMT offset in format "(+/-)HH:mm"
 * @param timeZone - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#timezone
 * @returns example: "-05:30", "+02:00"
 */
const getTimeZoneOffsetGMT = (timeZone: string): string => {
  const gmtOffset = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    timeZoneName: 'longOffset',
  })
    .format(new Date())
    .split('GMT')[1];

  return gmtOffset;
};
/**
 * Return offset in milliseconds
 * @param timeZone - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#timezone
 * @returns milliseconds
 */
const getOffsetInMsByTimeZone = (timeZone: string): number => {
  const hrMinOffset = parseFloat(
    getTimeZoneOffsetGMT(timeZone).replace(':', '.'),
  );

  return hrMinOffset * 60 * 60 * 1000;
};
/**
 * Returns time by time zone
 * @param dateTimeZeroed zeroed ISO-8601 date string: YYYY-MM-DDTHH:mm:ssZ
 * @param timeZone https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#timezone
 */
export const timeInTimeZone = (dateTimeZeroed: string, timeZone: string) => {
  const dateZeroed = new Date(dateTimeZeroed);
  const offsetInMs = getOffsetInMsByTimeZone(timeZone);

  return dateZeroed.getTime() + offsetInMs;
};
